import React, {useState, useCallback} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {formatErrors, roleNames} from "../../../constants";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {userCreateAction} from "../../../actions/usersAction";
import {i_copy} from "../../../icons";
import copy from 'copy-to-clipboard';
import { InputProfile } from '../../../utils/input/InputProfile';

export function UserInviteModal({trigger, open, onClose, ok}) {
  const [form, setForm] = useState({
    role_id: 1,
    email: '',
    last_name: '',
    first_name: '',
    patronymic_name: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(null);
  const dispatch = useDispatch();

  const copyLink = () => {
    copy(link);
    toast.success("Ссылка скопирована в буфер обмена!", {position: toast.POSITION.BOTTOM_RIGHT});
  };

  const handleChangeForm = useCallback((field, value) => {
    setForm((form) => {
      return {...form, [field]: value};
    });
  }, []);

  const handleSubmit = () => {
    if (loading) {
      return false;
    }

    let err = false;
    let errors = {};
    if (!form.email || !form.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
      err = true;
      errors.email = true;
    }
    if (!form.last_name) {
      err = true;
      errors.last_name = true;
    }
    if (!form.first_name) {
      err = true;
      errors.first_name = true;
    }

    setErrors(errors);
    console.log(err, errors);
    if (err) {
      return false;
    }

    setLoading(true);
    dispatch(userCreateAction({...form, role_id: +form.role_id})).then((data) => {
      setLoading(false);
      if (data.errors && data.errors.length > 0) {
        toast.error(formatErrors([data.errors[0]]), {position: toast.POSITION.BOTTOM_RIGHT});
      } else {
        ok();
        setLink(document.location.protocol + '//' + document.location.host + '/register?invite_code=' + data.invite_code);
      }
    }).catch((e) => {
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    }).finally(() => {
      setLoading(false);
    });
  };

  return <Modal open={open} onClose={onClose} trigger={trigger} triggerWrap={true}>
    <React.Fragment>
      <div className="modal__title">Добавить нового сотрудника</div>
      {link && <div className="modal__wrap">
        <div className="modal__help">Ссылка для входа сотрудника (действует 24 часа)</div>
        <div className="modal__group modal__group--flex">
          <input type="text" className="modal__input input" readOnly value={link} placeholder="Ссылка" />
          <button className="modal__icon" onClick={copyLink}>
            {i_copy()}
          </button>
        </div>
      </div>}
      {!link && <div className="profile__inner">
          <InputProfile type="text"
                        title="Фамилия"
                        name="last_name"
                        placeholder="Введите фамилию"
                        value={form.last_name}
                        error={errors.last_name || false}
                        disabled={loading}
                        onChange={(e) => handleChangeForm('last_name', e.target.value)}/>

          <InputProfile type="text"
                        title="Имя"
                        name="first_name"
                        placeholder="Введите имя"
                        value={form.first_name}
                        error={errors.first_name || false}
                        disabled={loading}
                        onChange={(e) => handleChangeForm('first_name', e.target.value)}/>

          <InputProfile type="text"
                        title="Отчество"
                        name="patronymic_name"
                        placeholder="Введите отчество"
                        value={form.patronymic_name}
                        error={errors.patronymic_name || false}
                        disabled={loading}
                        onChange={(e) => handleChangeForm('patronymic_name', e.target.value)}/>

          <InputProfile type="email"
                        title="Эл. почта"
                        name="email"
                        placeholder="Введите эл. почту"
                        value={form.email}
                        error={errors.email || false}
                        disabled={loading}
                        onChange={(e) => handleChangeForm('email', e.target.value)}/>

          <div className="profile__group">
            <label className="profile__label help">Роль сотрудника</label>
            <select name="role_id"
                  className={"dropdown__select select"}
                  value={form.role_id}
                  disabled={loading}
                  onChange={(e) => handleChangeForm('role_id', e.target.value)}>
                {roleNames.map((i, k) => <option key={'role_id_' + k} value={k + 1}>{i}</option>)}
            </select>
          </div>
      </div>}
      {!link && <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit}>Сохранить</button>
      </div>}
    </React.Fragment>
  </Modal>
};
